import React from "react";
import { Icon } from "@iconify/react";
import { Box, Typography } from "@mui/material";
import spokeIcon from "../assets/icons/Spoke.svg";
import TypeIcon from "./Reusables/HubSpokeIcon/TypeIcon";

function CenterType({ data }) {
  if (!data) return null;

  const center = {
    type: data.centerType,
    name: data.centerName,
    id: data.center?._id,
  };


  

  return (
   <Box>
  <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0 }}>
    <Box component="li" key={center.id}>
      <Box display="flex" alignItems="center">
        <TypeIcon type={center.type} size={15} />

        <Typography fontSize={14} ml={0.5}>
          {center?.name?.length > 20
            ? center?.name?.slice(0, 20) + "..."
            : center?.name}
        </Typography>
      </Box>
    </Box>
  </Box>
</Box>
  );
}

export default CenterType;
